// tslint:disable:no-commented-code
// tslint:disable:no-duplicate-string
// tslint:disable:only-arrow-functions
// tslint:disable:no-identical-functions

import {
  IDynamicBindableValue,
  IDynamicBindableValueCombination,
  IDynamicItemValue,
} from '@epicuro-next/models/platform/dynamic-elements/dynamic-elements';

import { getProvider } from '../../../utils/dynamic-items-utils';
import { getRecommendationsDataProviderItem } from '../../recommendations-provider';
import { PanelStatusEvent } from '../../types/panel-event';
import { SingleProductDataType } from '../../types/single-product-data-type';

import {
  getSquarePanelTemplate,
  ids as templateIds,
  propertyNames as templatePropertyNames,
} from './square-panel-template';

export const propertyNames = {
  ...templatePropertyNames,
  panelName: 'panelName',
  panelStyle: 'panelStyle',
};

export const ids = {
  ...templateIds,
};

export function createSquarePanelFromRecommendations(
  panelName: string,
  providers: {
    apiRequestPayloadPropertiesProvider: IDynamicItemValue;
    panelStatusEvent?: {
      noData?: IDynamicBindableValue | IDynamicBindableValueCombination;
      error?: IDynamicBindableValue | IDynamicBindableValueCombination;
    };
  },
  transformApiResponse: (resonse: unknown) => SingleProductDataType[],
) {
  const template = getSquarePanelTemplate('recommendations-data');

  template.productDataContainer.data.panelName = panelName;

  template.root.data.overrideProductTitleFromPropertyKey = 'masterProductTitle';

  const recommendationsData = getRecommendationsDataProviderItem({
    panelName: getProvider(template.productDataContainer, 'panelName'),
    apiRequestPayloadPropertiesProvider:
      providers.apiRequestPayloadPropertiesProvider,
  });

  template.root.children.push(recommendationsData);

  if (template.root.events !== undefined) {
    throw new Error(
      'Expected events at root to be undefined. No need to remove the events, but the code below would overwrite it, hence the implementation should change.',
    );
  }

  const providersPanelStatusEventError = providers.panelStatusEvent?.error;

  let errorPanelStatusEvent: IDynamicBindableValueCombination;
  if (providersPanelStatusEventError !== undefined) {
    errorPanelStatusEvent = {
      values: [providersPanelStatusEventError],
    };
  } else {
    errorPanelStatusEvent = {
      values: [getProvider(recommendationsData, 'hasError')],
      filter: function ([hasError]: [boolean]): boolean {
        return hasError;
      }.toString(),
    };
  }

  errorPanelStatusEvent.transform = function (): PanelStatusEvent {
    const event: PanelStatusEvent = {
      type: 'panel-status',
      data: 'hasError',
    };

    return event;
  }.toString();

  template.root.events = [errorPanelStatusEvent];

  template.productDataContainer.data.productData = {
    ...getProvider(recommendationsData, 'result'),
    transform: transformApiResponse.toString(),
  };

  return { ...template, recommendationsData };
}
